// libraries
import React from 'react'

// css
import '../../../../../css/components/WordCloud.styl'

// lib
import cloud from '_lib/WordCloud.js'
import convertToArray from '@st-operations/uikit/lib/convertToArray.js'
import computeMinMax from '@st-operations/uikit/lib/computeMinMax.js'
import computeSize from '@st-operations/uikit/lib/computeSize.js'

// component
class WordCloud extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: Math.random().toString(16).substr(2),
    }
    this.cloud = cloud()
    this.ref = React.createRef()
  }

  static get defaultProps() {
    return {
      height: -1, // height of the canvas
      limit: 10, // maximum number of words to show
      sort: '', // data sorter
      width: -1, // width of the canvas
      x: 0, // x position
      y: 0, // y position
    }
  }

  componentDidMount() {
    this.loadCloud()
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(this.props.data) !== JSON.stringify(prevProps.data) ||
      this.props.width !== prevProps.width ||
      this.props.height !== prevProps.height
    ) {
      this.loadCloud()
    }
  }

  loadCloud = () => {
    var { data, height, limit, sort, width, x, y } = this.props
    let { id } = this.state

    // compute canvas size
    var { height, width } = computeSize(width, height, 1920, 1080)

    // accept array: [{key, color, value}]
    // accept dict: {key: value}
    if (!Array.isArray(data)) {
      data = convertToArray(data, 'category', sort, limit)
    }

    // limit
    data = data.slice(0, limit)

    // multiply word length by index to find the overall most impactful word
    let biggestWordRelative = Math.max(...data.map((d) => d.key.length * d.value))
    while (biggestWordRelative > 100) {
      // keep value inside a useful range (0-100)
      biggestWordRelative /= 10
    }

    // compute min and max values
    let [min, max] = computeMinMax(data, 'value')

    // load cloud
    let cloud = this.ref.current
    cloud.innerHTML = ''
    this.cloud
      .size([width, height])
      .words(
        data.map((item) => {
          return {
            size: this.scale(
              item.value,
              // limit value between [0] and [1]
              // uses biggestWordRelative to reduce the overall size
              [1500 - biggestWordRelative * 15, 7000 - biggestWordRelative * 40],
              min,
              max
            ),
            text: item.key.replace(/_/g, ' '),
          }
        })
      )
      .padding(10)
      .rotate(() => {
        return 0
      })
      .font('Open Sans')
      .fontSize((d) => {
        return Math.sqrt(d.size)
      })
      .start()
      .draw(`#cloud-${id}`)

    // update state
    this.setState({
      height,
      width,
      x,
      y,
    })
  }

  scale(num, range, min, max) {
    return ((range[1] - range[0]) * (num - min)) / (max - min) + range[0]
  }

  render() {
    // read input
    let { id, height, width, x, y } = this.state

    // render
    return (
      <svg
        className="word-cloud"
        height={height}
        id={`cloud-${id}`}
        ref={this.ref}
        viewBox={`0 0 ${width || 0} ${height || 0}`}
        width={width}
        x={x}
        y={y}
      />
    )
  }
}

// export
export default WordCloud
